module.exports = __webpack_public_path__ + "img/chevron-down.b8f5e4b0.svg";